import React from "react";
import CommonDialog from "../ui/CommonDialog";
import GameRules from "./GameRules";

const GameRulesDialog = ({ open, onClose }) => {
  return (
    <CommonDialog
      open={open}
      onClose={onClose}
      title="📖 Game Manual"
      maxWidth="md"
      contentStyle={{
        padding: 0, 
        overflow: 'hidden'
      }}
    >
        <GameRules variant="popup" showTitle={false} />
    </CommonDialog>
  );
};

export default GameRulesDialog;

